import React from "react";

function Education() {
  return (

    <div class="card">
<div class="card-header" style={{textAlign:"left"}}>
  <h3>Education</h3>
</div>
<div class="card-body" style={{textAlign:"left"}}>
  <h5 class="card-title"> <a href="https://ddu.ac.in/" style={{color:"black"}}>
    Dharmsinh Desai University</a></h5>
  <p class="card-text">BTec. in Information Technology (2019-23): 8.63 CPI</p>
</div>
<div class="card-body" style={{textAlign:"left"}}>
  <h5 class="card-title">B. S. Patel School</h5>
  <p class="card-text">Higher Secondary CBSE Boards (2018-19): 91.4%</p>
  <p class="card-text">Secondary CBSE Boards (2016-17): 10 CGPA</p>
</div>
</div>

);
}

export default Education;